<template>
  <!-- 注册或绑定手机号页 -->
  <div class="registerPage">
    <div class="topInfo">
      <template v-if="type === 'bindWx'">
        <span class="registerTips">{{ $t('请绑定手机号码') }}</span>
      </template>
      <template v-else>
        <span class="registerTips">{{ $t('账号注册') }}</span>
        <div class="topInfoRight">
          <span>{{ $t('已有账号') }}</span>
          <a @click="switchTabs('login')">{{ $t('去登录') }}</a>
        </div>
      </template>
    </div>
    <a-form-model ref="ruleForm" class="registerForm" :model="form" :rules="rules">
      <a-form-model-item prop="phone">
        <a-input
          v-model.trim="form.phone"
          :placeholder="type === 'bindWx' ? $t('请输入手机号') : $t('请输入手机号/邮箱')"
          size="large"
        />
      </a-form-model-item>
      <a-form-model-item prop="verifycode">
        <div style="display: flex; font-size: 12px">
          <a-input
            v-model.trim="form.verifycode"
            class="verifycode-left"
            :placeholder="$t('请输入验证码')"
            size="large"
          />
          <a-button
            class="verifycode"
            size="large"
            :disabled="state.smsSendBtn"
            :loading="type !== 'bindWx' && !turnstileToken && !turnstileError"
            @click="
              () => {
                type === 'bindWx' ? sendCode() : beforeSendCode()
              }
            "
          >
            {{ (!state.smsSendBtn && `${$t('获取验证码')}`) || state.time + ' s' }}
          </a-button>
        </div>
      </a-form-model-item>

      <!-- Cloudflare Turnstile 验证容器 (仅注册需要) -->
      <div v-show="type !== 'bindWx'" id="turnstile-register-container" style="margin-bottom: 8px" />

      <a-popover
        v-if="type !== 'bindWx'"
        v-model="state.passwordLevelChecked"
        placement="right"
        :trigger="['focus']"
        :get-popup-container="(trigger) => trigger.parentElement"
      >
        <template #content>
          <div :style="{ width: '240px' }">
            <div :class="['user-register', passwordLevelClass]">
              {{ $t('强度') }}：<span>{{ passwordLevelName }}</span>
            </div>
            <a-progress :percent="state.percent" :show-info="false" :stroke-color="passwordLevelColor" />
            <div style="margin-top: 10px">
              <span>{{ $t('输入密码温馨提示') }}</span>
            </div>
          </div>
        </template>
        <a-form-model-item prop="password">
          <a-input-password
            v-model.trim="form.password"
            :placeholder="$t('请设置密码（6-18位）')"
            size="large"
            @click="state.passwordLevelChecked = true"
            @blur="state.passwordLevelChecked = false"
          />
        </a-form-model-item>
      </a-popover>
      <a-form-model-item v-if="type !== 'bindWx'" prop="password2">
        <a-input-password v-model.trim="form.password2" :placeholder="$t('请再次确认密码')" size="large" />
      </a-form-model-item>
      <!-- <a-form-model-item>
        <a-input v-model.trim="form.inviteCode" :placeholder="$t('请输入邀请码（选填）')" size="large" />
      </a-form-model-item> -->
      <a-form-model-item prop="protocol">
        <a-button type="primary" size="large" block :loading="loading" :disabled="!defaultSelorigin" @click="onSubmit">
          {{ type === 'bindWx' ? $t('绑定手机') : $t('立即注册') }}
        </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <div style="display: flex; align-items: baseline">
          <a-checkbox :checked="defaultSelorigin" @change="seloriginChange" />&nbsp;<span class="protocol">
            {{ $t('勾选表示您同意并愿意遵守云展动力平台以下协议政策') }}：
            <router-link to="/agreement/service" target="_blank">{{ $t('云展动力平台服务协议') }}</router-link>
            <router-link to="/privacy" target="_blank">{{ $t('法律声明与隐私权政策') }}</router-link>
            <router-link to="/copyright-legal-disclaimer" target="_blank">{{ $t('版权政策与法律说明') }}</router-link>
          </span>
        </div>
      </a-form-model-item>
    </a-form-model>
    <vImgCode v-if="imgCodeFlag" :visible.sync="imgCodeFlag" :phone="form.phone" :emitCodeOnly="true" @confimCode="confimCode" />
  </div>
</template>
<script>
import vImgCode from '@/components/business/imgCodeValidate.vue'
import { encryption } from '@/utils/util'
import { phonePattern, emailPattern } from '@/const/pattern'
import { getSmsCaptcha, getWxbindcode, register, wxBindCode, checkLoginName, firstLogin } from '@/api/login'
import { loadTurnstileScript, renderTurnstile, resetTurnstile, removeTurnstile } from '@/utils/turnstile'

const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强',
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success',
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a',
}
export default {
  name: 'RegisterPage',
  components: {
    vImgCode,
  },
  props: {
    // 弹窗登录或注册时传入reload 刷新当前页
    backPath: {
      type: String,
      default: '',
    },
    /**
     * @description: 当前页面类型, 有两种, 注册(register)或者绑定微信(bindWx)
     */
    type: {
      type: String,
      default: 'register',
    },
    wechatInfo: {
      type: Object,
      default: () => {
        return {
          avatarUrl: '',
          nickName: '',
          openId: '',
        }
      },
    },
  },
  data() {
    return {
      formCode: true,
      loading: false,
      form: {
        phone: '',
        verifycode: '',
        password: '',
        password2: '',
        selorigin: 1,
      },
      state: {
        time: 120,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000',
      },
      isPhone: false,
      isPhoneText: '',
      imgCodeFlag: false,
      registerBtn: false,

      defaultSelorigin: false,
      turnstileWidgetId: null,
      turnstileToken: '',
      turnstileError: false,
    }
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName() {
      return this.$t(levelNames[this.state.passwordLevel])
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel]
    },
    rules() {
      const baseRules = {
        phone: [
          {
            required: true,
            validator: this.handlePhone,
            trigger: 'blur',
          },
        ],
        verifycode: [
          {
            required: true,
            max: 999999,
            type: 'number',
            transform: (v) => Number(v),
            message: this.$t('请输入正确的验证码'),
            trigger: 'change',
          },
        ],
        protocol: [
          {
            required: true,
            validator: this.checkProtocol,
            trigger: 'change',
          },
        ],
      }
      return this.type === 'bindWx'
        ? baseRules
        : {
            ...baseRules,
            password: [
              {
                required: true,
                validator: this.handlePasswordLevel,
                trigger: 'change',
              },
            ],
            password2: [
              {
                required: true,
                validator: this.handlePasswordCheck,
                trigger: 'blur',
              },
            ],
          }
    },
  },
  async mounted() {
    try {
      await loadTurnstileScript()
      if (this.type !== 'bindWx') {
        this.turnstileWidgetId = renderTurnstile('#turnstile-register-container', {
          onSuccess: (token) => {
            this.turnstileToken = token
          },
          onExpired: () => {
            this.turnstileToken = ''
            if (this.turnstileWidgetId) resetTurnstile(this.turnstileWidgetId)
          },
          onError: () => {
            this.turnstileToken = ''
          },
        })
      }
    } catch (e) {
      console.error('[Register] Turnstile 初始化失败', e)
      this.turnstileError = true
    }
  },
  beforeDestroy() {
    if (this.turnstileWidgetId) {
      removeTurnstile(this.turnstileWidgetId)
    }
  },
  methods: {
    // 协议验证
    checkProtocol(rule, value, callback) {
      console.log('协议验证', this.form.selorigin)
      if (!this.form.selorigin) {
        return callback(new Error(this.$t('请阅读勾选协议')))
      }
      callback()
    },
    // 手机号验证
    handlePhone(rule, value, callback) {
      console.log('手机号码', value)
      if (value === '') {
        return callback(new Error(this.$t('请输入手机号码或邮箱')))
      }
      // this.formCode = !value.includes('@')
      if (!phonePattern.test(value) && !emailPattern.test(value)) {
        return callback(new Error(this.$t('请输入正确的手机号码或邮箱！')))
      }
      callback()
    },
    // 密码验证
    handlePasswordLevel(rule, value, callback) {
      console.log('密码验证', typeof value, value)
      let level = 0
      if (value === undefined) {
        return callback(new Error(this.$t('请输入密码')))
      }
      console.log(value.length)
      if (value.length < 6) {
        callback(new Error(this.$t('请输入至少6个字符')))
      }
      if (value.length > 18) {
        callback(new Error(this.$t('不能超过18位字符')))
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        const password2 = this.form.password2
        if (value && password2 && value.trim() === password2.trim()) {
          this.$refs.ruleForm.validateField(['password2'])
        }
        callback()
      } else {
        if (level === 0) {
          this.state.percent = 10
        }
        callback(new Error(this.$t('密码强度不够,不能纯数字或者纯字母')))
      }
    },
    // 密码再次验证
    handlePasswordCheck(rule, value, callback) {
      console.log('密码再次验证', value)
      const password = this.form.password
      console.log('password', password)
      if (!value) {
        callback(new Error(this.$t('请再次输入密码')))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error(this.$t('两次密码不一致')))
      }
      callback()
    },
    // 协议改变
    seloriginChange(e) {
      console.log(`checked = ${e.target.checked}`)
      if (e.target.checked) {
        this.defaultSelorigin = true
        this.form.selorigin = 1
      } else {
        this.defaultSelorigin = false
        this.form.selorigin = 0
      }
    },
    // 注册
    onSubmit() {
      if (!this.defaultSelorigin) {
        this.$message.warn(this.$t('请阅读勾选协议'))
        return
      }
      const {
        form: { phone, verifycode, password, selorigin, inviteCode },
      } = this
      console.log(this.form)
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true

          if (this.type === 'bindWx') {
            this.bindWechat({
              phone,
              verifycode,
              selorigin,
              inviteCode,
            })
          } else {
            this.register({
              phone,
              verifycode,
              password,
              selorigin,
              inviteCode,
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * @description: 注册功能
     * @param {*}
     * @return {*}
     */
    async register({ phone, verifycode, password, selorigin, inviteCode }) {
      const encodepassword = encryption(password)

      const { data, code, msg } = await register({
        channel: '',
        loginname: phone,
        password: encodepassword,
        repassword: encodepassword,
        inviteCode,
        verifycode,
        selorigin,
      })

      this.loading = false
      console.log('注册接口返回', data, code, msg, selorigin)

      if (code === 0) {
        this.$message.success(data)
        const userInput = {}
        userInput.username = phone
        userInput.password = password
        userInput.grant_type = 'password'
        userInput.scope = 'server'

        // 注册后-自动登录
        this.$store
          .dispatch('loginByUsername', userInput)
          .then(async (msg) => {
            if (msg) {
              this.$message.error(msg)
            } else {
              // 如果当前页面是 /aiSystemRecommend 判断是否第一次登录
              if (this.$route.path === '/aiSystemRecommend') {
                const res = await firstLogin()
                if (!res.data) {
                  this.$store.commit('SET_LOGIN_COOKIE', {
                    token: data.access_token,
                    refreshToken: data.refresh_token,
                  })

                  await this.$store.dispatch('getUserInfo')
                  this.$router.push('/firstLogin')
                  return
                }
              }
              // 判断是否第一次登录 结束

              if (this.backPath === 'reload') {
                this.$router.go(0)
              } else {
                this.$store
                  .dispatch('getUserInfo')
                  .then(() => {
                    this.$initWebIM({ status: 'normalLogin' })
                    this.$store.commit('switchPopupLoginStatus', false)
                  })
                  .catch((e) => {
                    // TODO 异常处理
                    console.log(e)
                  })
              }
            }
          })
          .catch((e) => {
            console.log('catch', e)
            // TODO 异常处理
            this.$serverError()
          })
      }
    },
    // 绑定手机微信
    async bindWechat({ phone, verifycode, selorigin, inviteCode }) {
      const { data, code, msg } = await wxBindCode({
        verifycode,
        phone,
        selorigin,
        inviteCode,
        avatarUrl: this.wechatInfo.avatarUrl,
        nickName: this.wechatInfo.nickName,
        openid: this.wechatInfo.openId,
      })

      this.loading = false
      console.log('绑定手机微信', data, code, msg, selorigin)

      if (code === 0) {
        this.$message.success(this.$t('绑定成功'))
        // 注册后-自动登录
        this.$store.commit('SET_LOGIN_COOKIE', {
          token: data.access_token,
          refreshToken: data.refresh_token,
        })

        this.$router.push({
          path: this.$route.query.backPath || '/',
        })

        if (this.backPath === 'reload') {
          this.$router.go(0)
        } else {
          this.$store
            .dispatch('getUserInfo')
            .then(() => {
              // 触发注册落地页
              this.$emit('ok')
            })
            .catch((e) => {
              // TODO 异常处理
              console.log(e)
            })
        }
      }
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 发送手机验证码-前
    beforeSendCode() {
      const {
        form: { phone },
      } = this
      this.isPhone = false
      console.log('发送验证码', phone)
      this.$refs.ruleForm.validateField(['phone'], async (err) => {
        if (!err) {
          // 验证手机号是否注册 // 检查登录名 2020年10月10日 新增了邮箱
          const { code, data, msg } = await checkLoginName(phone)
          if (code === 0) {
            switch (data.status) {
              case 1:
                this.$message.error(this.$t('该账号已注册'))
                break
              case 2:
                this.imgCodeFlag = true
                break
              case 3:
                // 如果 Turnstile 加载失败，降级强制显示图形验证码
                if (this.type !== 'bindWx' && !this.turnstileToken && this.turnstileError) {
                  this.imgCodeFlag = true
                } else {
                  this.sendCode()
                }
                break
            }
          } else {
            this.$message.error(msg)
          }
        }
      })
    },
    // 发送验证码
    async sendCode(flag = true, imgCode = undefined) {
      const {
        form: { phone },
        state,
        $message,
        $notification,
      } = this
      state.smsSendBtn = true
      const interval = window.setInterval(() => {
        if (state.time-- <= 0) {
          state.time = 120
          state.smsSendBtn = false
          window.clearInterval(interval)
        }
      }, 1000)
      console.log('验证码发送中', flag)
      if (flag) {
        const hide = $message.loading(this.$t('验证码发送中'), flag ? 0 : 1000)

        let code, msg
        if (this.type === 'bindWx') {
          const res = await getWxbindcode(phone)
          code = res.code
          msg = res.msg
        } else {
          const res = await getSmsCaptcha({ phone, cfTurnstileToken: this.turnstileToken || '', imgCode })
          code = res.code
          msg = res.msg

          this.turnstileToken = ''
          if (this.turnstileWidgetId) resetTurnstile(this.turnstileWidgetId)
        }

        console.log('获取验证码响应', code)
        if (code === 0 || code === 200) {
          this.imgCodeFlag = false
          setTimeout(hide, 2000)
          $notification.success({
            message: this.$t('提示'),
            description: this.$t('验证码发送成功,请注意查看'),
            duration: 8,
          })
        } else {
          setTimeout(hide, 1)
          clearInterval(interval)
          state.time = 120
          state.smsSendBtn = false
          $notification.error({
            message: this.$t('提示'),
            description: msg || this.$t('验证码发送失败'),
          })
          // this.requestFailed(err)
        }
      }
    },
    // 图形验证码输入正确后
    confimCode(imgCode) {
      // 我们不在这里直接设为 false，以防发送短信失败时还需要展示
      this.sendCode(true, imgCode)
    },
    requestFailed(err) {
      this.$notification.error({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误,请稍后再试',
        duration: 4,
      })
      this.registerBtn = false
    },
    switchTabs(e) {
      this.$emit('switchTabs', e)
    },
  },
}
</script>
<style lang="scss" scoped>
.registerPage {
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  margin-top: 50px;
  max-width: 1000px;
}

.topInfo {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 22px;

  .registerTips {
    color: #ff8a00;
    font-weight: 600;
  }

  .topInfoRight {
    color: #7d7d7d;

    a {
      text-decoration: underline;
    }
  }
}

.en {
  .verifycode-left {
    &::-webkit-input-placeholder {
      font-size: 12px;
    }
  }

  .verifycode {
    font-size: 12px;
  }

  .protocol {
    position: relative;
  }

  .protocol-detail {
    position: relative;
    top: -33px;
  }
}

.protocol {
  display: inline-block;
  line-height: 20px;
}

.verifycode-left {
  flex: 1;
  margin-right: 20px;
}

.verifycode {
  padding: 0 20px;
  width: auto;
  float: right;
}

.apply-card {
  background-color: #eef0f2;
  height: 190px;

  .name {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .description {
    font-size: 18px;
    margin-bottom: 20px;
  }

  a {
    font-size: 16px;
  }
}

.registerForm {
  ::v-deep .ant-form-item {
    margin-bottom: 10px;
  }
}
</style>
